import {
  crossGovernmentPathwayReturn,
  GFIE_CROSS_GOVERNMENT_ANSWER_FIELDS_BY_PATHWAY,
  pathwayDataReturn,
  submitterDetails,
} from '../pages/gfie/annexA';
import type { FormConfig } from '../types';

const formConfig: FormConfig = {
  live: true,
  id: 'gfie',
  formName: 'GFIE',
  title: 'GFIE',
  subTitle: 'Summary page',
  requiredFlag: true,
  showSections: true,
  sections: [
    {
      title: 'GFiE Pathway data Return',
      slug: 'annex-a-gfie-data-return',
      subsections: [
        {
          title: 'Submitter details',
          slug: 'submitter-details',
          pages: submitterDetails,
        },
        {
          title: 'Pathway data return',
          slug: 'pathway-data-return',
          dependsOn: 'submitter-details',
          pages: pathwayDataReturn,
        },
        {
          title: 'Cross Government Pathway',
          slug: 'cross-government-pathway-return',
          dependsOn: 'submitter-details',
          notRequiredWhen: [
            {
              field: 'gfie-pathways',
              condition: 'selectedOptionsNoneEqual',
              value: 'Yes',
              answerFieldsByOption: GFIE_CROSS_GOVERNMENT_ANSWER_FIELDS_BY_PATHWAY,
            },
          ],
          pages: crossGovernmentPathwayReturn,
        },
      ],
    },
  ],
};

export default formConfig;
